import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';
import ownerLevels from 'enums/ownerLevels';
import conversationCategories from 'enums/conversationCategories';
import conversationStatuses from 'enums/conversationStatuses';

import AdminFormWrapper from '../../presentational/AdminFormWrapper';
import AdminFormFields from '../../presentational/AdminFormFields';
import AdminFormButtons from '../../presentational/AdminFormButtons';
import Form from 'form/Form';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { TextField, Checkboxes } from 'mui-rff';

const useStyles = makeStyles(({ theme }) => ({
    checkboxContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        '& > *': {
            flex: '0 0 50%'
        }
    }
}));

const SearchConversationsForm = ({ searchParameters, onSubmit, isSubmitting = false }) => {
    const classes = useStyles();
    const { category } = searchParameters;

    const ownerLevelItems = Object.values(ownerLevels)
        .map(o => ({
            value: o.key,
            label: o.title
        }));

    const statusItems = Object.values(conversationStatuses)
        .map(o => ({
            value: o.key,
            label: o.title
        }));

    const createButton = (buttonCategory, buttonText, form) => {
        return (
            <Button
                type="submit"
                variant="contained"
                color={category === buttonCategory ? 'primary' : 'secondary'}
                onClick={() => { form.change('category', buttonCategory); }}
            >
                {buttonText}
            </Button>
        );
    };

    return (
        <AdminFormWrapper isSubmitting={isSubmitting}>
            <Form
                initialValues={searchParameters}
                onSubmit={onSubmit}
            >
                {({ form, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <AdminFormButtons>
                            { createButton(conversationCategories.general.key, 'General', form) }
                            { createButton(conversationCategories.faultReport.key, 'Fault report', form) }
                        </AdminFormButtons>
                        <AdminFormFields>
                            <TextField
                                name="query"
                                type="search"
                                label="Search sender or recipient"
                                variant="outlined"
                            />

                            <Box className={classes.checkboxContainer}>
                                <Box>
                                    <Checkboxes
                                        name="ownerLevels"
                                        label="Owner levels"
                                        data={ownerLevelItems}
                                    />
                                </Box>
                                <Box>
                                    <Checkboxes
                                        name="statuses"
                                        label="Statuses"
                                        data={statusItems}
                                    />
                                </Box>
                            </Box>
                        </AdminFormFields>

                        <AdminFormButtons>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Search
                            </Button>
                        </AdminFormButtons>
                    </form>
                )}
            </Form>
        </AdminFormWrapper>
    );
};

SearchConversationsForm.propTypes = {
    searchParameters: PropTypes.object,
    onSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool
};

export default SearchConversationsForm;
